/**
 * Get the contests with laps, newest first
 * @param {Object} state redux state
 * @returns {Array<Object>} contests
 */
export const getContests = ( { contests } ) => contests && Array.isArray( contests.list ) ? contests.list : []

/**
 * Get the chosen contest
 * @param {Object} state redux state
 * @returns {number} contest id, 0 when following the newest contest
 */
export const getSelectedContest = ( { contests } ) => contests ? contests.selected : 0
